import React from 'react';
import InputForm from '../InputForm/InputForm';

const Home = () => {
  return (
    <div>
      <InputForm />
    </div>
  );
};

export default Home;